<h1 mat-dialog-title>Response / Project Request Form</h1>
<div>Use this form to request a new emergency response or project be added to the tool.</div>
<mat-dialog-content style="display: flex; flex-direction: column;">
<app-field-coord-er-request-form (saved)="dialogRef.close()"></app-field-coord-er-request-form>
</mat-dialog-content>
